/**
 * Inline line-art SVG icons. They inherit `currentColor`, so colour them via
 * CSS on the parent. Used in place of emoji for the home tiles & settings gear.
 */
const svg = (paths: string): string =>
  `<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" ` +
  `stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">${paths}</svg>`;

export const ICONS = {
  // Skill tree: a root node branching into two.
  skills: svg(
    '<circle cx="12" cy="4.5" r="2.3"/><circle cx="5" cy="19.5" r="2.3"/>' +
      '<circle cx="19" cy="19.5" r="2.3"/>' +
      '<path d="M12 6.8v3.4M12 10.2c0 3.4-7 3-7 7M12 10.2c0 3.4 7 3 7 7"/>',
  ),
  // Achievements: a medal with ribbon tails.
  achievements: svg('<circle cx="12" cy="9" r="6"/><path d="M15.5 13.8 17 22l-5-3-5 3 1.5-8.2"/>'),
  // Leaderboard: a three-place podium.
  leaderboard: svg(
    '<rect x="9" y="8" width="6" height="13" rx="1"/>' +
      '<rect x="2.5" y="12" width="6" height="9" rx="1"/>' +
      '<rect x="15.5" y="11" width="6" height="10" rx="1"/>',
  ),
  // Settings: a gear.
  settings: svg(
    '<circle cx="12" cy="12" r="3"/>' +
      '<path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z"/>',
  ),
} as const;
